module.exports = __webpack_public_path__ + "img/2.9c638b11.jpg";